import React from 'react'

const ModalCard = ({ isOpen, onclose, title, description, price, fPicName }) => {


    const content =
        (

            <>
                {/* backdro */}
                <div onClick={onclose} className={` fixed inset-0 flex justify-center items-center transition-colors z-50 ${isOpen ? "visible bg-gray-600/70" : "invisible"}`}>
                    {/* modal */}
                    <div onClick={(e) => e.stopPropagation()} className={`bg-white rounded-xs shadow p-6 transition-all ${isOpen ? "scale-100 opacity-100" : "scale-125 opacity-0"}`}>
                        <button type="button"
                            onClick={onclose}
                            className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 absolute top-2 right-2">
                            <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>

                        <div
                            onClick={onclose}
                            className={`${isOpen ? "visible " : "invisible"} max-h-auto max-w-auto px-2 py-2 mx-auto sm:max-w-xl md:max-w-xl`}>

                            <div className="grid max-w-screen-lg gap-1 lg:grid-cols-2 sm:mx-auto">
                                <div className="grid grid-cols-2 gap-2">
                                    <img
                                        className="object-cover w-full h-30 col-span-2 rounded shadow-xs"
                                        // src="https://images.pexels.com/photos/3182746/pexels-photo-3182746.jpeg?auto=compress&amp;cs=tinysrgb&amp;dpr=2&amp;h=750&amp;w=1260"
                                        src={`${fPicName}`}
                                        alt=""
                                    />
                                    <img
                                        className="object-cover h-30 rounded shadow-xs"
                                        // src="https://images.pexels.com/photos/3184296/pexels-photo-3184296.jpeg?auto=compress&amp;cs=tinysrgb&amp;dpr=2&amp;h=750&amp;w=1260"
                                        src={`${fPicName}`}
                                        alt=""
                                    />
                                    <img
                                        className="object-cover w-full h-30 rounded shadow-xs"
                                        // src="https://images.pexels.com/photos/3184338/pexels-photo-3184338.jpeg?auto=compress&amp;cs=tinysrgb&amp;dpr=2&amp;h=750&amp;w=1260"
                                        src={`${fPicName}`}
                                        alt=""
                                    />
                                </div>
                                <div className="flex flex-col px-2 justify-center">
                                    <div className="pb-1 mb-1 border-b">
                                        <h2 className="mb-4 font-sans text-xl font-bold tracking-tight text-gray-900 sm:text-xl sm:leading-none">
                                            {/* Unauthorized to access! */}
                                            {title}
                                        </h2>
                                        <h2 className="mb-4 font-sans text-xl font-bold tracking-tight text-gray-900 sm:text-xl sm:leading-none">
                                            {/* Unauthorized to access! */}
                                            $ {price}
                                        </h2>
                                        <p className="text-sm text-gray-900">
                                            {description}
                                        </p>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )

    return content
}

export default ModalCard